import React, { SVGProps } from "react";

export default function ProjectsIcon({ color, ...props }: SVGProps<any>) {
  return (
    <svg viewBox="0 0 27 26" width={27} height={26} {...props}>
      <path
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.58}
        d="M14.578 1.573l2.793 5.882c.163.35.486.597.865.664l6.179.933a1.26 1.26 0 01.632 2.117l-4.429 4.492a1.292 1.292 0 00-.347 1.11l1.05 6.38a1.185 1.185 0 01-1.655 1.312l-5.59-3.058a1.067 1.067 0 00-1.043 0L7.44 24.463a1.185 1.185 0 01-1.655-1.312l1.055-6.38a1.292 1.292 0 00-.344-1.11l-4.433-4.492a1.26 1.26 0 01.632-2.117l6.18-.933c.378-.067.7-.315.864-.664l2.793-5.882a1.114 1.114 0 012.047 0z"
      />
    </svg>
  );
}
